export default __webpack_public_path__ + "static/media/web-development-svgrepo-com.9a3fb7e0.svg";